import { Link } from 'react-router-dom';

export default function Auditorias() {
  const features = [
    {
      icon: 'ri-file-search-line',
      title: 'Revisión de Normativas',
      description:
        'Análisis exhaustivo del cumplimiento de normativas legales vigentes.',
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Verificación de Permisos',
      description:
        'Control de permisos operacionales y autorizaciones requeridas.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Auditoría de Procedimientos',
      description:
        'Evaluación de procedimientos de trabajo y protocolos de seguridad.',
    },
    {
      icon: 'ri-file-chart-line',
      title: 'Planes de Acción',
      description:
        'Entrega de planes corregidos con acciones concretas y plazos.',
    },
  ];

  return (
    <section
      id="auditorias"
      className="py-24 bg-gradient-to-b from-gray-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* IMAGE */}
          <div className="relative order-2 lg:order-1">
            
<div className="relative rounded-2xl overflow-hidden shadow-2xl">
  <img
    src="/images/services/auditorias-cumplimiento.webp"
    alt="Auditorías de Cumplimiento HSE"
    width={900}
    height={830}
    loading="lazy"
    decoding="async"
    className="w-full h-full object-cover object-center"
  />
</div>


            {/* FLOATING CARD */}
            <div className="absolute -top-8 -right-8 bg-teal-600 rounded-xl p-6 shadow-xl max-w-xs">
              <div className="flex items-center gap-3 text-white">
                <i className="ri-search-eye-line text-3xl"></i>

                <div>
                  <div className="text-2xl font-bold">
                    Detección
                  </div>

                  <div className="text-sm text-white/90">
                    de Brechas
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CONTENT */}
          <div className="order-1 lg:order-2">
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Auditorías HSE
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Auditorías de{' '}
              <span className="text-teal-600">
                Cumplimiento HSE
              </span>
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Revisamos normativas, permisos, procedimientos y
              documentación crítica para detectar brechas y entregar
              planes corregidos.
            </p>

            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              Nuestras auditorías identifican desviaciones y
              oportunidades de mejora en tu sistema de gestión HSE.
              Entregamos informes detallados con hallazgos priorizados y
              planes de acción específicos para cerrar brechas de
              cumplimiento.
            </p>

            <Link
              to="/contacto"
              className="bg-teal-600 text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors inline-flex items-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
            >
              Quiero cotizar

              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* FEATURES */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all border border-gray-100 hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center mb-4">
                <i
                  className={`${feature.icon} text-2xl text-white`}
                ></i>
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {feature.title}
              </h3>

              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
